import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

interface GoogleClass {
  id: string;
  name: string;
  description?: string;
  section?: string;
  added: boolean;
  existingClassId?: string;
}

export async function syncGoogleClassroomClasses(
  selectedClasses: GoogleClass[]
): Promise<any> {
  const { data, error } = await supabase.functions.invoke(
    "syncGoogleClassroomClasses",
    {
      body: { selectedClasses },
    }
  );

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return {
      importedEmails: [],
      newImportedStudents: [],
      failedEmails: [],
      error: errorMessage.error,
    };
  }

  return {
    message: data?.message,
    importedCount: data?.importedCount ?? 0,
    importedEmails: data?.importedEmails ?? [],
    newImportedStudents: data?.newImportedStudents ?? [],
    failedEmails: data?.failedEmails ?? [],
    error: null,
  };
}
